/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelLoanDto } from '../../models/backend-business-angel-loan-dto';
import { BackendPatchedBusinessAngelLoanRequestDto } from '../../models/backend-patched-business-angel-loan-request-dto';

export interface VentureFundsBusinessAngelLoansPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedBusinessAngelLoanRequestDto;
}

export function ventureFundsBusinessAngelLoansPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelLoansPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelLoansPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelLoanDto>;
    }),
  );
}

ventureFundsBusinessAngelLoansPartialUpdate$FormData.PATH = '/api/venture_funds/business-angel-loans/{id}/';
